
//STYLES
import { PageResumo } from "./style";

//ASSETS
import logoTtivos from '../../../../assets/img/logo-2.png';
import { gerarKey } from "../../../../utils";
import dayjs from "dayjs";
import { HeaderTable } from "../../../CustomUi/table/headerTable";
import { BodyTable } from "../../../CustomUi/table/bodyTable";
import { RowTable } from "../../../CustomUi/table/rowTable";
import { RowItem } from "../../../CustomUi/table/rowItem";
import { SmallCircleNC } from "../../../../Views/app/monitoramento/resumo/components/gavetaResumo/components/modalPragas/components/SmallCircleNC";
import { ResumoMonitoramento } from "../../../../services/monitoramento/resumo/get";
import { descricaoEscala, filtrarPragas, obterVariacaoes, ProcessarResumo } from "./meta";
import { useAccess } from "../../../../context/useAccess";
import { localConfig } from "../../../../Configs/localConfig";
import { CheckboxValueType } from "antd/lib/checkbox/Group";
import { ordenarDadosResumo } from "../../../../Views/app/monitoramento/resumo/components/gavetaResumo/meta";
import { SmallCircleEscala } from "./component/SmallCircleNC";

//PROPS
interface Props {
    licenca: string;
    dadosResumoMonitoramento: ResumoMonitoramento;
    nome_propriedade: string;
    data_selecionada_fotos_moni: string;
    lista_filtrar_talhoes: any[];
    pragas_selecionadas_resumo: CheckboxValueType[];
    agrupar_resumo?: boolean;
}

export const Resumo: React.FC<Props> = ({ licenca, dadosResumoMonitoramento, nome_propriedade, data_selecionada_fotos_moni, 
    lista_filtrar_talhoes, pragas_selecionadas_resumo, agrupar_resumo }) => {

    //CONST
    let { nameCliente } = useAccess();
    let { nomeSafra } = localConfig();

    //FUNCTION
    function rolarAteMapa(id: string) {
        
        const element = document.getElementById(id);

        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    }
    
    return (
        <PageResumo>
            <h2 className="PageResumo__title">Resumo do monitoramento</h2>

            {(ProcessarResumo(dadosResumoMonitoramento?.itens ?? [], lista_filtrar_talhoes??[], data_selecionada_fotos_moni, Boolean(agrupar_resumo)) ?? []).map(({nome_talhao, cod_talhao, dados_resumo}, index) => {
                return (
                    <div className="PageResumo__table" key={gerarKey(index)} style={{ pageBreakInside: index > 0 ? 'avoid' : undefined }}>
                        <div className="PageResumo__table__header">
                            <div className="PageResumo__table__header__title">
                                Cliente:
                            </div>
                            <div className="PageResumo__table__header__value">
                                {String(nameCliente).toLowerCase()}
                            </div>
                        </div>
                        <div className="PageResumo__table__header">
                            <div className="PageResumo__table__header__title">
                                Propriedade:
                            </div>
                            <div className="PageResumo__table__header__value">
                                {String(nome_propriedade).toLowerCase()}
                            </div>
                        </div>
                        <div className="PageResumo__table__header">
                            <div className="PageResumo__table__header__title">
                                Data:
                            </div>
                            <div className="PageResumo__table__header__value">
                                {dayjs(data_selecionada_fotos_moni).format("DD/MM/YYYY")}
                            </div>
                        </div>

                        <div className="PageResumo__table__header">
                            <div className="PageResumo__table__header__title bolder">
                                {agrupar_resumo ? 'Talhões' : 'Talhão'}:
                            </div>
                            <div className="PageResumo__table__header__value bolder">
                                {nome_talhao}
                            </div>
                        </div>

                        <div className="PageResumo__table__content">
                            <HeaderTable 
                                itens={[
                                    {valor: 'Praga', width: 385}, 
                                    {valor: 'Pontos', width: 110}, 
                                    {valor: 'Métrica', width: 200}, 
                                    {valor: 'Min', width: 115},
                                    {valor: 'Méd', width: 115},
                                    {valor: 'Max', width: 115},
                                ]}
                            />
                            <BodyTable>
                                {filtrarPragas(ordenarDadosResumo(dados_resumo) ?? [], pragas_selecionadas_resumo, agrupar_resumo).map(({ cod_especie_e_cod_variacao, especie, variacao, colmo, pontos, tipo_metrica_nome, minimo, media, maximo, inverter_escala, nivel_controle }, index)=> {
                                    let is_safra_milho = String(nomeSafra).toLowerCase().includes('milho');
                                    return (
                                        <RowTable key={index} style={{pageBreakInside:'avoid'}} onDoubleClick={()=>{rolarAteMapa(cod_especie_e_cod_variacao+'_'+cod_talhao)}}>
                                            <RowItem width={385} style={{flexDirection:'column',alignItems: 'flex-start', justifyContent:'center'}} >
                                                <span style={{fontWeight: 600}}>{especie}</span>
                                                {variacao!==null && <span style={{color: 'var(--text-color-light)', fontWeight: 500}}>{variacao}</span> }
                                                {is_safra_milho  && <small style={{fontWeight:600, color: 'var(--text-color-light)'}}>colmo: {colmo}</small>}
                                                {agrupar_resumo && <small style={{fontWeight:600, color: 'var(--text-color-light)'}}>{obterVariacaoes(ordenarDadosResumo(dados_resumo), especie)}</small> }
                                            </RowItem>
                                            <RowItem width={110} >
                                                {pontos}
                                            </RowItem>
                                            <RowItem width={200} >
                                                {tipo_metrica_nome}
                                            </RowItem>
                                            <RowItem width={115} gap={7}>
                                                {tipo_metrica_nome === 'Escala'
                                                    ? <>{descricaoEscala(Number(minimo))} <SmallCircleEscala valor={Number(minimo)} /> </>
                                                    : <>{Number(minimo).toFixed(2)} <SmallCircleNC valor={Number(minimo)} nivel_controle={Number(nivel_controle)} is_invertido={Boolean(inverter_escala)} /></>
                                                } 
                                            </RowItem>
                                            <RowItem width={115} gap={7} >
                                                {tipo_metrica_nome === 'Escala'
                                                    ? <>{descricaoEscala(Number(media))} <SmallCircleEscala valor={Number(media)} /></>
                                                    : <>{Number(media).toFixed(2)} <SmallCircleNC valor={Number(media)} nivel_controle={Number(nivel_controle)} is_invertido={Boolean(inverter_escala)} /></>
                                                }
                                            </RowItem>
                                            <RowItem width={115} gap={7} >
                                                {tipo_metrica_nome=== 'Escala'
                                                    ? <>{descricaoEscala(Number(maximo))} <SmallCircleEscala valor={Number(maximo)}  /></>
                                                    : <>{Number(maximo).toFixed(2)} <SmallCircleNC valor={Number(maximo)} nivel_controle={Number(nivel_controle)} is_invertido={Boolean(inverter_escala)} /></>
                                                }
                                            </RowItem>
                                        </RowTable>
                                    )
                                })}
                            </BodyTable>
                        </div>
                    </div>
                )
            })}

            <div className="PageResumo__radape">
                <img src={logoTtivos} className="PageResumo__radape__logo" alt="ttivos Gestão Rural" />
                licenciado para: {licenca}
            </div>
        </PageResumo>
    )
};